import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import usePageData from '~/helpers/use-page-data';
import useLanguageContext from '~/contexts/language';
import { useIntl } from 'react-intl';
export default function FindTranslation() {
    const subject = useParams().subject;
    const pageData = usePageData(`pages/${subject}-books`);
    if (!pageData) {
        return null;
    }
    if (pageData.error || !pageData.translations[0]) {
        return React.createElement(NotAvailable, null);
    }
    return React.createElement(NavigateToTranslation, { translations: pageData.translations[0] });
}
function NavigateToTranslation({ translations }) {
    const { language } = useLanguageContext();
    const tx = translations.find((t) => t.locale === language);
    const navigate = useNavigate();
    if (!tx) {
        return React.createElement(NotAvailable, null);
    }
    window.setTimeout(() => {
        navigate(`/subjects/${tx.slug.replace('-books', '')}`, { replace: true });
    }, 0);
    return null;
}
function NotAvailable() {
    const { formatMessage } = useIntl();
    return (React.createElement("div", { className: 'boxed' },
        React.createElement("h1", null,
            formatMessage({ id: 'subject.notAvailableText' }),
            ' ',
            React.createElement("a", { href: '/subjects' }, formatMessage({ id: 'subject.notAvailableLinkText' })))));
}
